export default {
  en: {
    title: 'Recordings',
    subtitle: 'Adjust recordings settings between local and cloud',
    testCredentials: 'Test credentials',
    aws: {
      name: 'Bucket name',
      region: 'Bucket region',
      accessKey: 'Access key id',
      secretKey: 'Secret access key',
      oidc: 'Enable OIDC',
      roleArn: 'Role ARN',
    },
    azure: {
      textCredentials: 'Credentials in JSON format',
      accountName: 'Account name',
      keyAccount: 'Key account',
      protocol: 'Protocol',
      endpoint: 'Blob endpoint',
      container: 'Container name',
    },
    gcp: {
      credentialsInJSON: 'Credentials in JSON format',
      errorJSON: 'The JSON credential is not valid, please fix',
      bucketName: 'Bucket name',
      projectId: 'Project Id',
      privateKeyId: 'Private key id',
      privateKey: 'Private key',
      emailClient: 'Email client',
      clientId: 'Client id',
      uri: 'Authentication URI',
      tokenUri: 'URI Token',
      x509Uri: 'x509 URI provider',
      x509Client: 'x509 client provider'
    },
    ftp: {
      hostname: 'Hostname',
      username: 'Username',
      port: 'Port',
      password: 'Password',
      tls: 'TLS connection',
      ssh: 'SSH connection',
      hintTLS: 'We will send the recording using a secure connection, check that you can send files using TLS.',
      alertRoot: 'For security, you cannot use a "root" user for the connection',
      alertDeactivateTLS: 'Disabling TLS verification prevents us from delivering recordings over a secure connection, and inhibits attacks such as Man-in-the-middle.'
    },
    errors: {
      credentials: 'Error detected when testing credentials',
      valid: 'Valid credentials',
      validDescription: 'We have connected to your external storage successfully'
    },
    form: {
      storageType: 'Storage type',
      storageProvider: 'Storage provider',
      settingName: 'Setting name',
      generalSettings: 'General settings',
      automaticRecording: {
        label: 'Automatic recording',
        hint: 'Recording will automatically start when you start the call and stop when you end it. Your agents won\'t see the recording feature'
      },
      showRecordingStatus: {
        label: 'Show recording indicator',
        hint: 'This will show the recording indicator to your customers'
      },
      alertOnActivate: 'Remember you need to assign this recording setting to a segment or calendar, otherwise the recording will be not available.',
      uploadConstraints: 'Upload constraints',
      billingAlert: 'If you do not activate the "Automatic upload" or "Delete backup" options, you will be using our storage with a minimum billing of 100GB per month',
      automaticUpload: {
        label: 'Automatic upload',
        hint: 'If it is active, we will send the recording immediately to your external cloud. Otherwise you can do it manually from the 1 to 1 recording log',
      },
      deleteBackup: {
        label: 'Delete backup',
        hint: 'If it is active, when uploading to your external cloud, we delete our backup immediately. Otherwise you can delete manually from the recording log 1 by 1',
      },
      trackRecord: {
        label: 'Tacks to record',
        hint: 'By default, audio for video calls is always recorded. (If you need to deactivate the audio and only record video, contact us to deactivate this track)',
        screenLabel: 'Screen',
        screenHint: 'We will record shared screens (screen sharing) during the video call. (If the shared screen includes audio it will also be recorded)'
      },
      videoBits: {
        label: 'Video bits per second',
        hint: 'Bit rate corresponds to the number of bits per second that are added to the video track, a higher value is more quality and size. (Default: standard quality)',
      },
      audioBits: {
        label: 'Audio bits per second',
        hint: 'Bit rate corresponds to the number of bits per second that are added to the audio track, a higher value is more quality and size. (Default: standard quality)'
      },
      videoWidth: {
        label: 'Video width',
        hint: 'Width in pixels of the video to obtain. A higher value is more sharpness and size'
      },
      videoHeight: {
        label: 'Video height',
        hint: 'Height in pixels of the video to obtain. A higher value is more sharpness and size'
      },
      bytesMax: {
        label: 'Bytes limit',
        hint: 'Maximum size allowed per file or participant. Above this value, recording stops. (Default: 2GB)'
      },
      errorAtLeastTrack: 'You must select at least 1 track to record',
      storageCredentials: 'Storage credentials of {storage}',
      securityAlert: 'For security, once the credentials are configured you will no longer be able to view or edit them, only replace them',
      advancedSettings: '{action} advanced settings',
      alertAdvancedSettings: 'Changing these settings without knowledge could result in large or poor quality files, including corrupted recordings',
      alertLimit: 'For security reasons, recordings are limited to a maximum of 3 hours and 2GB per file or participant.'

    }
  },
  es: {
    title: 'Grabaciones',
    subtitle: 'Ajustar configuraciones de grabaciones entre local y nube',
    testCredentials: 'Probar credenciales',
    aws: {
      name: 'Nombre del bucket',
      region: 'Región del bucket',
      accessKey: 'ID de clave de acceso',
      secretKey: 'Clave de acceso secreta',
      oidc: 'Habilitar OIDC',
      roleArn: 'ARN del rol',
    },
    azure: {
      textCredentials: 'Credenciales en formato JSON',
      accountName: 'Nombre de la cuenta',
      keyAccount: 'Clave de la cuenta',
      protocol: 'Protocolo',
      endpoint: 'Punto final de Blob',
      container: 'Nombre del contenedor',
    },
    gcp: {
      credentialsInJSON: 'Credenciales en formato JSON',
      errorJSON: 'La credencial JSON no es válida, por favor corrige',
      bucketName: 'Nombre del bucket',
      projectId: 'ID del proyecto',
      privateKeyId: 'ID de la clave privada',
      privateKey: 'Clave privada',
      emailClient: 'Correo electrónico del cliente',
      clientId: 'ID del cliente',
      uri: 'URI de autenticación',
      tokenUri: 'URI de token',
      x509Uri: 'Proveedor de URI x509',
      x509Client: 'Proveedor de cliente x509'
    },
    ftp: {
      hostname: 'Nombre del host',
      username: 'Nombre de usuario',
      port: 'Puerto',
      password: 'Contraseña',
      tls: 'Conexión TLS',
      ssh: 'Conexión SSH',
      hintTLS: 'Enviaremos la grabación utilizando una conexión segura, verifica que puedas enviar archivos utilizando TLS.',
      alertRoot: 'Por seguridad, no puedes utilizar un usuario "root" para la conexión',
      alertDeactivateTLS: 'Desactivar la verificación TLS impide que entreguemos grabaciones a través de una conexión segura, e inhibe ataques como el de Man-in-the-middle.'
    },
    errors: {
      credentials: 'Error detectado al probar las credenciales',
      valid: 'Credenciales válidas',
      validDescription: 'Nos hemos conectado a tu almacenamiento externo con éxito'
    },
    form: {
      storageType: 'Tipo de almacenamiento',
      storageProvider: 'Proveedor de almacenamiento',
      settingName: 'Nombre de la configuración',
      generalSettings: 'Configuraciones generales',
      automaticRecording: {
        label: 'Grabación automática',
        hint: 'La grabación comenzará automáticamente cuando inicies la llamada y se detendrá cuando la termines. Tus agentes no verán la función de grabación'
      },
      showRecordingStatus: {
        label: 'Mostrar indicador de grabación',
        hint: 'Esto mostrará el indicador de grabación a sus clientes'
      },
      automaticBackup: {
        label: 'Respaldo automático',
        hint: 'La grabación comenzará automáticamente cuando inicies la llamada y se detendrá cuando la termines. Tus agentes no verán la función de grabación.',
      },
      alertOnActivate: 'Recuerde que necesita asignar esta configuración de grabación a un segmento o calendario, de lo contrario la grabación no estará disponible.',
      uploadConstraints: 'Restricciones de carga',
      billingAlert: 'Si no activas las opciones de "Carga automática" o "Eliminar respaldo", estarás utilizando nuestro almacenamiento con una facturación mínima de 100GB por mes',
      automaticUpload: {
        label: 'Carga automática',
        hint: 'Si está activa, enviaremos la grabación inmediatamente a tu nube externa. De lo contrario, puedes hacerlo manualmente desde el registro de grabación 1 a 1',
      },
      deleteBackup: {
        label: 'Eliminar respaldo',
        hint: 'Si está activa, al cargar en tu nube externa, eliminamos nuestro respaldo inmediatamente. De lo contrario, puedes eliminar manualmente desde el registro de grabación 1 por 1',
      },
      trackRecord: {
        label: 'Pistas a grabar',
        hint: 'Por defecto, siempre se graba el audio para las videollamadas. (Si necesitas desactivar el audio y solo grabar video, contáctanos para desactivar esta pista)',
        screenLabel: 'Pantalla',
        screenHint: 'Grabaremos pantallas compartidas (compartir pantalla) durante la videollamada. (Si la pantalla compartida incluye audio, también se grabará)'
      },
      videoBits: {
        label: 'Bits de video por segundo',
        hint: 'La tasa de bits corresponde al número de bits por segundo que se agregan a la pista de video, un valor más alto es más calidad y tamaño. (Predeterminado: calidad estándar)',
      },
      audioBits: {
        label: 'Bits de audio por segundo',
        hint: 'La tasa de bits corresponde al número de bits por segundo que se agregan a la pista de audio, un valor más alto es más calidad y tamaño. (Predeterminado: calidad estándar)'
      },
      videoWidth: {
        label: 'Ancho de video',
        hint: 'Ancho en píxeles del video a obtener. Un valor más alto es más nitidez y tamaño'
      },
      videoHeight: {
        label: 'Altura de video',
        hint: 'Altura en píxeles del video a obtener. Un valor más alto es más nitidez y tamaño'
      },
      bytesMax: {
        label: 'Límite de bytes',
        hint: 'Tamaño máximo permitido por archivo o participante. Por encima de este valor, la grabación se detiene. (Predeterminado: 2GB)'
      },
      errorAtLeastTrack: 'Debes seleccionar al menos 1 pista para grabar',
      storageCredentials: 'Credenciales de almacenamiento de {storage}',
      securityAlert: 'Por seguridad, una vez configuradas las credenciales, ya no podrás verlas ni editarlas, solo reemplazarlas',
      advancedSettings: '{action} configuraciones avanzadas',
      alertAdvancedSettings: 'Cambiar estas configuraciones sin conocimiento podría resultar en archivos grandes o de mala calidad, incluidas grabaciones corruptas',
      alertLimit: 'Por razones de seguridad, las grabaciones están limitadas a un máximo de 3 horas y 2GB por archivo o participante.'
    }
  },
  fr: {
    title: 'Enregistrements',
    subtitle: 'Ajustez les paramètres des enregistrements entre local et cloud',
    testCredentials: 'Tester les identifiants',
    aws: {
      name: 'Nom du bucket',
      region: 'Région du bucket',
      accessKey: 'ID de clé d\'accès',
      secretKey: 'Clé d\'accès secrète',
      oidc: 'Activer OIDC',
      roleArn: 'ARN du rôle',
    },
    azure: {
      textCredentials: 'Identifiants au format JSON',
      accountName: 'Nom du compte',
      keyAccount: 'Clé du compte',
      protocol: 'Protocole',
      endpoint: 'Point de terminaison Blob',
      container: 'Nom du conteneur',
    },
    gcp: {
      credentialsInJSON: 'Identifiants au format JSON',
      errorJSON: 'Les identifiants JSON ne sont pas valides, veuillez corriger',
      bucketName: 'Nom du bucket',
      projectId: 'ID du projet',
      privateKeyId: 'ID de la clé privée',
      privateKey: 'Clé privée',
      emailClient: 'Email du client',
      clientId: 'ID du client',
      uri: 'URI d\'authentification',
      tokenUri: 'URI du token',
      x509Uri: 'Fournisseur URI x509',
      x509Client: 'Fournisseur client x509'
    },
    ftp: {
      hostname: 'Nom d\'hôte',
      username: 'Nom d\'utilisateur',
      port: 'Port',
      password: 'Mot de passe',
      tls: 'Connexion TLS',
      ssh: 'Connexion SSH',
      hintTLS: 'Nous enverrons l\'enregistrement en utilisant une connexion sécurisée, assurez-vous que vous pouvez envoyer des fichiers en utilisant TLS.',
      alertRoot: 'Pour des raisons de sécurité, vous ne pouvez pas utiliser un utilisateur "root" pour la connexion',
      alertDeactivateTLS: 'Désactiver la vérification TLS empêche l\'envoi sécurisé des enregistrements et expose à des attaques telles que l\'attaque de l\'homme du milieu.'
    },
    errors: {
      credentials: 'Erreur détectée lors du test des identifiants',
      valid: 'Identifiants valides',
      validDescription: 'Nous nous sommes connectés avec succès à votre stockage externe'
    },
    form: {
      storageType: 'Type de stockage',
      storageProvider: 'Fournisseur de stockage',
      settingName: 'Nom de la configuration',
      generalSettings: 'Paramètres généraux',
      automaticRecording: {
        label: 'Enregistrement automatique',
        hint: 'L\'enregistrement commencera automatiquement lorsque vous démarrez l\'appel et s\'arrêtera lorsque vous le terminez. Vos agents ne verront pas la fonction d\'enregistrement'
      },
      showRecordingStatus: {
        label: 'Afficher l\'indicateur d\'enregistrement',
        hint: 'Cela affichera l\'indicateur d\'enregistrement à vos clients'
      },
      automaticBackup: {
        label: 'Sauvegarde automatique',
        hint: 'L\'enregistrement commencera automatiquement lorsque vous démarrez l\'appel et s\'arrêtera lorsque vous le terminez. Vos agents ne verront pas la fonction d\'enregistrement.',
      },
      alertOnActivate: 'N\'oubliez pas d\'attribuer ce paramètre d\'enregistrement à un segment ou à un calendrier, sinon l\'enregistrement ne sera pas disponible.',
      uploadConstraints: 'Contraintes de téléchargement',
      billingAlert: 'Si vous n\'activez pas les options "Téléchargement automatique" ou "Supprimer la sauvegarde", vous utiliserez notre stockage avec une facturation minimale de 100 Go par mois',
      automaticUpload: {
        label: 'Téléchargement automatique',
        hint: 'S\'il est activé, nous enverrons l\'enregistrement immédiatement à votre cloud externe. Sinon, vous pouvez le faire manuellement depuis le registre d\'enregistrement 1 à 1',
      },
      deleteBackup: {
        label: 'Supprimer la sauvegarde',
        hint: 'S\'il est activé, lors du téléchargement sur votre cloud externe, nous supprimons immédiatement notre sauvegarde. Sinon, vous pouvez la supprimer manuellement depuis le registre d\'enregistrement 1 par 1',
      },
      trackRecord: {
        label: 'Pistes à enregistrer',
        hint: 'Par défaut, l\'audio est toujours enregistré pour les appels vidéo. (Si vous avez besoin de désactiver l\'audio et d\'enregistrer uniquement la vidéo, contactez-nous pour désactiver cette piste)',
        screenLabel: 'Écran',
        screenHint: 'Nous enregistrerons les écrans partagés (partage d\'écran) pendant l\'appel vidéo. (Si l\'écran partagé inclut l\'audio, il sera également enregistré)'
      },
      videoBits: {
        label: 'Bits vidéo par seconde',
        hint: 'Le débit binaire correspond au nombre de bits par seconde ajoutés à la piste vidéo, une valeur plus élevée signifie plus de qualité et de taille. (Par défaut : qualité standard)',
      },
      audioBits: {
        label: 'Bits audio par seconde',
        hint: 'Le débit binaire correspond au nombre de bits par seconde ajoutés à la piste audio, une valeur plus élevée signifie plus de qualité et de taille. (Par défaut : qualité standard)'
      },
      videoWidth: {
        label: 'Largeur de la vidéo',
        hint: 'Largeur en pixels de la vidéo à obtenir. Une valeur plus élevée signifie plus de netteté et de taille'
      },
      videoHeight: {
        label: 'Hauteur de la vidéo',
        hint: 'Hauteur en pixels de la vidéo à obtenir. Une valeur plus élevée signifie plus de netteté et de taille'
      },
      bytesMax: {
        label: 'Limite de bytes',
        hint: 'Taille maximale autorisée par fichier ou participant. Au-delà de cette valeur, l\'enregistrement s\'arrête. (Par défaut : 2 Go)'
      },
      errorAtLeastTrack: 'Vous devez sélectionner au moins 1 piste à enregistrer',
      storageCredentials: 'Identifiants de stockage pour {storage}',
      securityAlert: 'Pour des raisons de sécurité, une fois les identifiants configurés, vous ne pourrez plus les voir ni les modifier, seulement les remplacer',
      advancedSettings: '{action} paramètres avancés',
      alertAdvancedSettings: 'Modifier ces paramètres sans connaissance pourrait entraîner des fichiers volumineux ou de mauvaise qualité, y compris des enregistrements corrompus',
      alertLimit: 'Pour des raisons de sécurité, les enregistrements sont limités à un maximum de 3 heures et 2 Go par fichier ou participant.'
    }
  }

}
